import {makeAutoObservable} from "mobx";

export const PushType = {
    All: 'All',
    Locale: 'Locale',
    Group: 'Group',
    Select: 'select'
}

export const TabType = {
    title: 'title',
    subTitle: 'subTitle',
}

export const PushStatusType ={
    Completed: 'Completed',
    Failed: 'Failed',
    Wait: 'Wait',
    Progress: 'Progress'
}

const languageCodes = ["EN", "KO", "ZH", "JA", "TH", "VN", "MN", "ID", "RU", "TW"];

const languageLocaleMap = {
    "US": "EN",
    "KR": "KO",
    "CN": "ZH",
    "JP": "JA",
    "TH": "TH",
    "VN": "VN",
    "MN": "MN",
    "ID": "ID",
    "RU": "RU",
    "TW": "TW",
    "ETC": "ETC",
};

const defaultTranslate = {
    createdDatetime: "",
    id: 0,
    isSend: true,
    pushAlertId: 0,
    subTitle: "",
    title: "",
    updatedDatetime: ""
};

const logPrefix = "[PushStore]"

export default class PushStore {

    constructor(props) {
        this.pushRepository = props.pushRepository;
        this.commonStore = props.commonStore;
        this.localeStore = props.localeStore;
        this.dialogStore = props.dialogStore;

        this.rowsPerPage = 10;
        this.page = 0;
        this.sortColumn = '';
        this.isAscending = true;
        this.totalCount = 0;

        this.pushList = [];

        this.initPushDetail();

        makeAutoObservable(this);

    }

    initPushDetail = () => {

        this.pushTranslate = languageCodes.map(code => ({...defaultTranslate, languageCode: code}));

        this.title = "";
        this.subtitle = "";

        this.id = 0;
        this.localeCode = "";
        this.localeGroupId = 0;
        this.type = "";
        this.reservationDatetime = "";

        this.currentTab = TabType.title;
        this.selectOption = PushType.All;
        this.selectLocale = PushType.Select;
        this.selectGroupId = "";
    }

    setRowsPerPage = (rowsPerPage, id, locale) => {
        this.page = 0;
        this.rowsPerPage = rowsPerPage;
        this.getPushes(id, locale);
    }

    setPage = (page, id, locale) => {
        this.page = page;
        this.getPushes(id, locale);
    }

    setSortColumn = (column) => {
        this.sortColumn = column;
    }

    setCurrentTab = (text) => {
        this.currentTab = text;
    }

    setIsAscending = (isAscending) => {
        this.isAscending = isAscending;
    }

    setTotalCount = (count) => {
        this.totalCount = count;
    }

    setPushList = (array) => {
        this.pushList = array;
    }

    setPushTranslate = (array, locale) => {
        this.pushTranslate = array;

        array.forEach(item => {
            if (item.languageCode === locale) {
                this.setTitle(item.title);
                this.setSubtitle(item.subTitle);
            }
        });
    }

    setId = (id) => {
        this.id = id;
    }

    setLocaleCode = (code) => {
        this.localeCode = code;
    }

    setLocaleGroupId = (groupId) => {
        this.localeGroupId = groupId;
    }

    setTitle = (title) => {
        this.title = title;
    };

    setSubtitle = (subtitle) => {
        this.subtitle = subtitle;
    };

    setType = (type) => {
        this.type = type;
    }

    setReservationDatetime = (time) => {
        this.reservationDatetime = time;
    }

    setSelectOption = (option, callback) => {
        if (option === PushType.All) {
            this.setSelectLocale(PushType.Select);
            this.setSelectGroupId("");
            this.pushTranslate = languageCodes.map(code => ({...defaultTranslate, languageCode: code}));
        }
        this.selectOption = option;
        callback && callback();
    }

    setSelectLocale = (locale) => {
        this.selectLocale = locale;
    }

    setSelectGroupId = (groupId) => {
        this.selectGroupId = groupId;
        if (groupId === PushType.All && this.selectOption === PushType.Group) {
            this.setSelectOption(PushType.Locale);
        }
    }

    getCurrentIndexWithLangCode = (languageCode) => {
        return this.pushTranslate.findIndex(push => push.languageCode === languageCode);
    }

    setSend = (send, index) => {
        this.pushTranslate[index].isSend = !send;
    }

    setContents = (data, locale) => {
        if (data.pushType === PushType.All) {
            this.setPushTranslate(data.contents, locale);
        } else {
            this.setPushTranslate(data.contents, languageLocaleMap[data.localeCode]);
        }
    }

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    };

    * getPushes(id, locale, callback) {
        this.commonStore.setLoadingState('WAITING...');
        try {
            console.log(logPrefix, 'Start Get Pushes');
            const url = `?userId=${id}&isAscending=${this.isAscending}&lang=${locale.toUpperCase()}&limit=${this.rowsPerPage}&offset=${this.page * this.rowsPerPage}`;
            const response = yield this.pushRepository.getPushes(url);
            this.setPushList(response.data.pushAlertRes);
            this.setTotalCount(response.data.totalCount);
            console.log(logPrefix, 'Finished Get Pushes');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed Get Pushes error: ' + e);
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    setPushElement = (index, type, value) => {
        this.pushTranslate[index][type] = value;
    }


    * translatePush(index, targetLang, currentLang, text, type, callback) {
        this.commonStore.setLoadingState('Translating...');
        try {
            console.log(logPrefix, 'Start translate Push.');
            const url = `translate?target-lang=${targetLang}&current-lang=${currentLang}&text=${text}`
            const response = yield this.pushRepository.getPushTranslate(url);
            callback && callback(index, type, response.data);
        } catch (e) {
            console.log(logPrefix, 'Failed translate Push.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * translateAllPush(lang, text, type, callback) {
        this.commonStore.setLoadingState('Translating...');
        try {
            console.log(logPrefix, 'Start translate All Notices.');
            const url = `translate/all?lang=${lang}&text=${text}`;
            const response = yield this.pushRepository.getPushTranslateAll(url);
            callback && callback(lang, type, response.data, this.commonStore.initLoadingState);
        } catch (e) {
            console.log(logPrefix, 'Failed translate All Notices.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    setPushTranslations = async (lang, type, data, callback) => {
        for (const content of this.pushTranslate) {
            if (data.length && data.length > 0) {
                for (const datum of data) {
                    if (lang !== content.languageCode && content.languageCode === datum.lang) {
                        content[type] = datum.translation;
                    }
                }
            }
        }
        await callback && callback();
    }


    * getPushContents(pushId, locale, callback, errorCallback) {
        this.commonStore.setLoadingState('WAITING...');
        try {
            console.log(logPrefix, 'Start get push Contents.');
            const url = `detail?id=${pushId}`
            const response = yield this.pushRepository.getPushDetail(url);
            this.setType(response.data.pushType);
            this.setSelectOption(response.data.pushType, () => this.setContents(response.data, locale));
            this.setLocaleCode(response.data.localeCode);
            this.setId(response.data.id);
            this.setLocaleGroupId(response.data.localeGroupId);
            this.setReservationDatetime(response.data.reservationDatetime)
            if (response.data.pushType !== PushType.All) {
                this.setSelectLocale(response.data.localeCode);
                if (response.data.pushType === PushType.Locale) {
                    this.setSelectGroupId(PushType.All);
                } else {
                    this.setSelectGroupId(response.data.localeGroupId);
                }
            }
            console.log(logPrefix, 'Finished get push Contents.');
            response.data.localeCode && callback && callback(response.data.localeCode);
            if (response.data.status === PushStatusType.Completed || response.data.status === PushStatusType.Failed) {
                errorCallback && errorCallback();
            }
        } catch (e) {
            console.log(logPrefix, 'Failed get push Contents.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * createAllPush(callback) {
        this.commonStore.setLoadingState('Registering...');
        try {
            console.log(logPrefix, 'Start create Push.');
            const data = {
                contents: this.pushTranslate,
                id: this.id,
                ...(this.selectLocale !== PushType.Select && {localeCode: this.selectLocale}),
                ...(this.selectGroupId !== PushType.All && {localeGroupId: this.selectGroupId}),
                pushType: this.selectOption,
                reservationDatetime: this.reservationDatetime,
            }
            data.contents.forEach((content, index) => {
                if (content.languageCode === this.localeStore.locale.toUpperCase()) {
                    content.title = this.title;
                    content.subTitle = this.subtitle;
                }
            });
            const timeoutGroups = yield this.pushRepository.checkPush("/checks", data);
            if (!!timeoutGroups?.data?.length) {
                this.openErrorDialog({
                    titleText: '푸시 알림',
                    text: `그룹의 시간이 예약한 시간을 이미 지났습니다.\n[${timeoutGroups?.data}]`
                })
            }
            yield this.pushRepository.postPush(data);
            console.log(logPrefix, 'Finished create Push.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed create Push.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * createLocalePush(callback, openConfirm) {
        this.commonStore.setLoadingState('Registering...');
        try {
            console.log(logPrefix, 'Start create Push.');
            const data = {
                contents: [{
                    title: this.title,
                    subTitle: this.subtitle,
                    languageCode: languageLocaleMap[this.selectLocale],
                    isSend: true,
                }],
                id: this.id,
                ...(this.selectLocale !== PushType.Select && {localeCode: this.selectLocale}),
                ...(this.selectGroupId !== PushType.All && {localeGroupId: this.selectGroupId}),
                pushType: this.selectOption,
                reservationDatetime: this.reservationDatetime,
            }
            const timeoutGroups = yield this.pushRepository.checkPush("/checks", data);
            if (!!timeoutGroups?.data?.length) {
                this.openErrorDialog({
                    titleText: '푸시 알림',
                    text: `그룹의 시간이 예약한 시간을 이미 지났습니다.\n[${timeoutGroups?.data}]`
                })
            }
            yield this.pushRepository.postPush(data);
            console.log(logPrefix, 'Finished create Push.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed create Push.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * updateAllPush(callback) {
        this.commonStore.setLoadingState('Updating...');
        try {
            console.log(logPrefix, 'Start update Push.');
            const data = {
                contents: this.pushTranslate,
                id: this.id,
                ...(this.selectLocale !== PushType.Select && {localeCode: this.selectLocale}),
                ...(this.selectGroupId !== PushType.All && {localeGroupId: this.selectGroupId}),
                pushType: this.selectOption,
                reservationDatetime: this.reservationDatetime,
            }
            data.contents.forEach((content, index) => {
                if (content.languageCode === this.localeStore.locale.toUpperCase()) {
                    content.title = this.title;
                    content.subTitle = this.subtitle;
                }
            });
            const timeoutGroups = yield this.pushRepository.checkPush("/checks", data);
            if (!!timeoutGroups?.data?.length) {
                this.openErrorDialog({
                    titleText: '푸시 알림',
                    text: `그룹의 시간이 예약한 시간을 이미 지났습니다.\n[${timeoutGroups?.data}]`
                })
            }
            yield this.pushRepository.putPush(data);
            console.log(logPrefix, 'Finished update Push.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed update Push.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * updateLocalePush(callback) {
        this.commonStore.setLoadingState('Registering...');
        try {
            console.log(logPrefix, 'Start update Push.');
            const data = {
                contents: [{
                    title: this.title,
                    subTitle: this.subtitle,
                    languageCode: languageLocaleMap[this.selectLocale],
                    isSend: true,
                }],
                id: this.id,
                ...(this.selectLocale !== PushType.Select && {localeCode: this.selectLocale}),
                ...(this.selectGroupId !== PushType.All && {localeGroupId: this.selectGroupId}),
                pushType: this.selectOption,
                reservationDatetime: this.reservationDatetime,
            }
            const timeoutGroups = yield this.pushRepository.checkPush("/checks", data);
            if (!!timeoutGroups?.data?.length) {
                this.openErrorDialog({
                    titleText: '푸시 알림',
                    text: `그룹의 시간이 예약한 시간을 이미 지났습니다.\n[${timeoutGroups?.data}]`
                })
            }
            yield this.pushRepository.putPush(data);
            console.log(logPrefix, 'Finished update Push.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed update Push.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * deletePush(id, callback) {
        try {
            console.log(logPrefix, 'Start delete Push.');
            const url = `?id=${id}`
            yield this.pushRepository.deletePush(url);
            console.log(logPrefix, 'Finished delete Push');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed delete Push.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

}